import {
  Checkbox,
  DatePicker,
  DateRange,
  Select,
  ThemeProvider,
} from "@veneer/core";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import useSearchSelect  from "../../../hooks/searchSelect/useSearchSelect";

// Crear un componente común para los bloques compartidos
export const AgendaCreationBlock = (props: any) => {
  const {
    typeOfVisitID,
    labelSubretail,
    handleChangeSubRetail,
    subretailData,
    subRetail,
    onClearSubRetail,
    disableSubretail,
    labelPointOfSale,
    handleChangePointOfSale,
    pointOfSaleData,
    pointOfSale,
    setPointOfSale,
    disablePointOfSale,
    errorPos,
    endDate,
    handleChangeStartDate,
    startDate,
    errorDatePicker,
    theme,
    labelStartTime,
    startTime,
    handleChangeStartTime,
    labelEndTime,
    endTime,
    labelStardDate,
    labelEndDate,
    handleChangeEndTime,
    labelMonday,
    checkboxMonday,
    onChangeCheckboxCreateAgenda,
    labelTuesday,
    checkboxTuesday,
    labelWednesday,
    checkboxWednesday,
    labelThursday,
    checkboxThursday,
    labelFriday,
    checkboxFriday,
    labelSaturday,
    checkboxSaturday,
    labelSunday,
    checkboxSunday,
    labelVisitDate,
    visitDate,
    handleChangePointOfSaleList,
    handleChangeSubRetailList,
    subretailDataCopy,
    setSubretailData,
    pointOfSaleDataCopy,
    setPointOfSaleData
  } = props;
  const { handleSearch } = useSearchSelect();


  switch (typeOfVisitID) {
    case 1:
      return (
        <div className="createAgendaPermanent">
          <Select
            className="createAgendaSelect"
            label={labelSubretail}
            onChange={(e) => handleChangeSubRetail(e.value)}
            options={subretailData}
            value={subRetail}
            onClear={() => onClearSubRetail()}
            disabled={disableSubretail}
            onSearch={(query: string) =>
              handleSearch(query, subretailDataCopy, setSubretailData)
            }
            searchDelay={500}
            showSearch={true}
          />
          <Select
            className="createAgendaSelect"
            label={labelPointOfSale}
            onChange={(e) => handleChangePointOfSale(e.value)}
            options={pointOfSaleData}
            value={pointOfSale}
            onClear={() => setPointOfSale([])}
            disabled={disablePointOfSale}
            error={errorPos}
            onSearch={(query: string) =>
              handleSearch(query, pointOfSaleDataCopy, setPointOfSaleData)
            }
            searchDelay={500}
            showSearch={true}
          />

          <DatePicker
            className="createAgendaDatePicker"
            blockPastDates
            clearIcon={false}
            endDate={endDate}
            onChange={(date) => handleChangeStartDate(date as DateRange)}
            orientation="horizontal"
            range
            startDatePlaceholder="mm/dd/yyyy"
            endDatePlaceholder="mm/dd/yyyy"
            format="LL"
            startDate={startDate}
            startDateLabel={labelStardDate}
            endDateLabel={labelEndDate}
            maxDate={moment(startDate).add(12, "months")}
            minimumNights={1}
            error={errorDatePicker}
          />

          <div className="createAgendaTimes">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <ThemeProvider theme={theme}>
                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelStartTime}
                  value={startTime}
                  onChange={(value) => handleChangeStartTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />

                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelEndTime}
                  value={endTime}
                  onChange={(value) => handleChangeEndTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />
              </ThemeProvider>
            </LocalizationProvider>
          </div>

          <div className="createAgendaDays">
            <Checkbox
              className="createAgendaCheckbox"
              label={labelMonday}
              value={checkboxMonday}
              checked={checkboxMonday}
              onChange={() => onChangeCheckboxCreateAgenda(1)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelTuesday}
              value={checkboxTuesday}
              checked={checkboxTuesday}
              onChange={() => onChangeCheckboxCreateAgenda(2)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelWednesday}
              value={checkboxWednesday}
              checked={checkboxWednesday}
              onChange={() => onChangeCheckboxCreateAgenda(3)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelThursday}
              value={checkboxThursday}
              checked={checkboxThursday}
              onChange={() => onChangeCheckboxCreateAgenda(4)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelFriday}
              value={checkboxFriday}
              checked={checkboxFriday}
              onChange={() => onChangeCheckboxCreateAgenda(5)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelSaturday}
              value={checkboxSaturday}
              checked={checkboxSaturday}
              onChange={() => onChangeCheckboxCreateAgenda(6)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelSunday}
              value={checkboxSunday}
              checked={checkboxSunday}
              onChange={() => onChangeCheckboxCreateAgenda(7)}
            />
          </div>
        </div>
      );
    case 2:
    case 7:
      return (
        <div className="createAgendaVisit">
          <Select
            className="createAgendaSelect"
            label={labelSubretail}
            onChange={(e) => handleChangeSubRetail(e.value)}
            options={subretailData}
            value={subRetail}
            onClear={() => onClearSubRetail()}
            disabled={disableSubretail}
            onSearch={(query: string) =>
              handleSearch(query, subretailDataCopy, setSubretailData)
            }
            searchDelay={500}
            showSearch={true}
          />
          <Select
            className="createAgendaSelect"
            label={labelPointOfSale}
            onChange={(e) => handleChangePointOfSale(e.value)}
            options={pointOfSaleData}
            value={pointOfSale}
            onClear={() => setPointOfSale([])}
            disabled={disablePointOfSale}
            error={errorPos}
            onSearch={(query: string) =>
              handleSearch(query, pointOfSaleDataCopy, setPointOfSaleData)
            }
            searchDelay={500}
            showSearch={true}
          />

          <DatePicker
            className="createAgendaDatePicker"
            label={labelVisitDate}
            onChange={(date) => handleChangeStartDate(date as DateRange)}
            clearIcon={false}
            value={visitDate}
            placeholder="mm/dd/yyyy"
            format="L"
            blockPastDates
          />

          <div className="createAgendaTimes">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <ThemeProvider theme={theme}>
                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelStartTime}
                  value={startTime}
                  onChange={(value) => handleChangeStartTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />
 
                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelEndTime}
                  value={endTime}
                  onChange={(value) => handleChangeEndTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />
              </ThemeProvider>
            </LocalizationProvider>
          </div>
        </div>
      );
    case 3:
      return (
        <div className="createAgendaPermanent">
          <Select
            className="createAgendaSelect"
            label={labelSubretail}
            onChange={(e) => handleChangeSubRetailList(e.value)}
            options={subretailData}
            value={subRetail}
            onClear={() => onClearSubRetail()}
            disabled={disableSubretail}
            multiple
            onSearch={(query: string) =>
              handleSearch(query, subretailDataCopy, setSubretailData)
            }
            searchDelay={500}
            showSearch={true}
          />
          <Select
            className="createAgendaSelect"
            label={labelPointOfSale}
            onChange={(e) => handleChangePointOfSaleList(e.value)}
            options={pointOfSaleData}
            value={pointOfSale}
            onClear={() => setPointOfSale([])}
            disabled={disablePointOfSale}
            error={errorPos}
            multiple
            onSearch={(query: string) =>
              handleSearch(query, pointOfSaleDataCopy, setPointOfSaleData)
            }
            searchDelay={500}
            showSearch={true}
          />

          <DatePicker
            className="createAgendaDatePicker"
            blockPastDates
            clearIcon={false}
            endDate={endDate}
            onChange={(date) => handleChangeStartDate(date as DateRange)}
            orientation="horizontal"
            range
            startDatePlaceholder="mm/dd/yyyy"
            endDatePlaceholder="mm/dd/yyyy"
            format="LL"
            startDate={startDate}
            startDateLabel={labelStardDate}
            endDateLabel={labelEndDate}
            maxDate={moment(startDate).add(12, "months")}
            minimumNights={1}
            error={errorDatePicker}
          />

          <div className="createAgendaTimes">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <ThemeProvider theme={theme}>
                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelStartTime}
                  value={startTime}
                  onChange={(value) => handleChangeStartTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />

                <TimePicker
                  className="createAgendaTimePicker"
                  label={labelEndTime}
                  value={endTime}
                  minTime={startTime}
                  onChange={(value) => handleChangeEndTime(value)}
                  renderInput={(params) => <TextField {...params} />}
                  minutesStep={10}
                  ampm={false}
                />
              </ThemeProvider>
            </LocalizationProvider>
          </div>

          <div className="createAgendaDays">
            <Checkbox
              className="createAgendaCheckbox"
              label={labelMonday}
              value={checkboxMonday}
              checked={checkboxMonday}
              onChange={() => onChangeCheckboxCreateAgenda(1)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelTuesday}
              value={checkboxTuesday}
              checked={checkboxTuesday}
              onChange={() => onChangeCheckboxCreateAgenda(2)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelWednesday}
              value={checkboxWednesday}
              checked={checkboxWednesday}
              onChange={() => onChangeCheckboxCreateAgenda(3)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelThursday}
              value={checkboxThursday}
              checked={checkboxThursday}
              onChange={() => onChangeCheckboxCreateAgenda(4)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelFriday}
              value={checkboxFriday}
              checked={checkboxFriday}
              onChange={() => onChangeCheckboxCreateAgenda(5)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelSaturday}
              value={checkboxSaturday}
              checked={checkboxSaturday}
              onChange={() => onChangeCheckboxCreateAgenda(6)}
            />
            <Checkbox
              className="createAgendaCheckbox"
              label={labelSunday}
              value={checkboxSunday}
              checked={checkboxSunday}
              onChange={() => onChangeCheckboxCreateAgenda(7)}
            />
          </div>
        </div>
      );
    default:
      return null;
  }
};